import { resolveDisplayValue } from '@psyomics/surveyjs-core';

import { capitaliseFirstChar } from '../../../../../utils/capitalise-first-char';
import { truncateText } from '../../../../../utils/truncate-text';
import { Answers, Survey } from '../../survey-types';

import { getQuestionByName } from './surveys';

type QuestionItem = { question: string };

const formatAnswer = (answer: string | undefined, truncateTo: number) => {
  if (!answer) {
    return 'Not Completed';
  }

  return truncateText(capitaliseFirstChar(answer), truncateTo);
};

const getAnswerByQuestionName = (questionItem: QuestionItem, answers: Answers) => {
  return answers[questionItem.question]?.toString()?.trim();
};

const getQuestionData = ({
  questionItem,
  answers,
  survey,
  truncateTo,
}: {
  questionItem: QuestionItem;
  answers: Answers;
  survey: Survey;
  truncateTo: number;
}) => {
  const questionName = questionItem.question;
  const questionObj = getQuestionByName(survey, questionName);
  const answer = answers[questionName]?.toString();
  const formattedAnswer = formatAnswer(answer, truncateTo);
  const wasTruncated = isAnswerTruncated(answer, truncateTo);

  return {
    answer,
    formattedAnswer,
    questionName,
    questionObj,
    wasTruncated,
  };
};

const getQuestionsToShow = (detailed: string, selectedQuestions: Array<QuestionItem>, answers: Answers) => {
  if (detailed === 'true') {
    return selectedQuestions;
  }

  return selectedQuestions
    .filter((questionItem) => {
      return getAnswerByQuestionName(questionItem, answers);
    })
    .slice(0, 1);
};

const isAnswerTruncated = (answer: string | undefined, truncateTo: number) => {
  if (!answer) {
    return false;
  }
  return truncateTo > 0 && answer.length > truncateTo;
};

const getDisplayValues = (survey: Survey | undefined, questionName: string): string[] => {
  const question = survey?.model.getQuestionByName(questionName);
  const rawAnswer = survey?.model.getValue(questionName);

  if (!question) return [];
  if (rawAnswer === null || rawAnswer === undefined) return [];

  const resolved = resolveDisplayValue(question, rawAnswer);
  const resolvedArray = Array.isArray(resolved) ? resolved : [resolved];
  return resolvedArray.map(String);
};

export { getDisplayValues, getQuestionData, getQuestionsToShow, isAnswerTruncated };
